import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './lib/i18n/config'; // i18n konfigürasyonunu import et
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

